import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Container from '@mui/material/Container';
import Button from '../components/Button';
import Typography from '../components/Typography';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const item: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

const number = {
  fontSize: 24,
  fontFamily: 'default',
  color: 'secondary.main',
  fontWeight: 'medium',
};

const image = {
  height: 55,
  my: 4,
};

function ProductHowItWorks() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', bgcolor: 'secondary.light', overflow: 'hidden' }}
    >
      <Container
        sx={{
          mt: 10,
          mb: 15,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/static/themes/ChemQuiz/productCurvyLines.png"
          alt="curvy lines"
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            top: -180,
            opacity: 0.7,
          }}
        />
        <Typography variant="h4" marked="center" component="h2" sx={{ mb: 14 }}>
          Этапы олимпиады
        </Typography>
        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>1.</Box>
                <HowToRegIcon sx={{ fontSize: 55, color: 'primary.main', my: 4 }} />
                <Typography variant="h5" align="center">
                  Регистрация участников
                </Typography>
                <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                  Заполните форму регистрации и получите доступ к заданиям первого тура
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>2.</Box>
                <AssignmentIcon sx={{ fontSize: 55, color: 'primary.main', my: 4 }} />
                <Typography variant="h5" align="center">
                  Выполнение заданий
                </Typography>
                <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                  Решите задачи отборочного тура онлайн. Лучшие участники проходят в финал
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Box sx={number}>3.</Box>
                <EmojiEventsIcon sx={{ fontSize: 55, color: 'primary.main', my: 4 }} />
                <Typography variant="h5" align="center">
                  Финальный этап
                </Typography>
                <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                  Очный тур с практическими заданиями и награждением победителей
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
        <Button
          color="secondary"
          size="large"
          variant="contained"
          component="a"
          href="/sign-up"
          sx={{ mt: 8 }}
        >
          Зарегистрироваться
        </Button>
      </Container>
    </Box>
  );
}

export default ProductHowItWorks;
